export var parseRequestArgs = function parseRequestArgs(documentOrOptions, variables, requestHeaders) {
  return documentOrOptions.document ? documentOrOptions : {
    document: documentOrOptions,
    variables: variables,
    requestHeaders: requestHeaders,
    signal: undefined
  };
};
export var parseRawRequestArgs = function parseRawRequestArgs(queryOrOptions, variables, requestHeaders) {
  return queryOrOptions.query ? queryOrOptions : {
    query: queryOrOptions,
    variables: variables,
    requestHeaders: requestHeaders,
    signal: undefined
  };
};
export var parseBatchRequestArgs = function parseBatchRequestArgs(documentsOrOptions, requestHeaders) {
  return documentsOrOptions.documents ? documentsOrOptions : {
    documents: documentsOrOptions,
    requestHeaders: requestHeaders,
    signal: undefined
  };
};
export var parseRequestExtendedArgs = function parseRequestExtendedArgs(urlOrOptions, document) {
  for (var _len = arguments.length, variablesAndRequestHeaders = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    variablesAndRequestHeaders[_key - 2] = arguments[_key];
  }
  var variables = variablesAndRequestHeaders[0],
    requestHeaders = variablesAndRequestHeaders[1];
  return urlOrOptions.document ? urlOrOptions : {
    url: urlOrOptions,
    document: document,
    variables: variables,
    requestHeaders: requestHeaders,
    signal: undefined
  };
};
export var parseRawRequestExtendedArgs = function parseRawRequestExtendedArgs(urlOrOptions, query) {
  for (var _len2 = arguments.length, variablesAndRequestHeaders = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    variablesAndRequestHeaders[_key2 - 2] = arguments[_key2];
  }
  var variables = variablesAndRequestHeaders[0],
    requestHeaders = variablesAndRequestHeaders[1];
  return urlOrOptions.query ? urlOrOptions : {
    url: urlOrOptions,
    query: query,
    variables: variables,
    requestHeaders: requestHeaders,
    signal: undefined
  };
};